import { ChevronDown } from 'lucide-react';
import React from 'react';

import { cn } from '@/utils';

interface TeamSeparatorRowProps {
  teamName: string;
  agentCount: number;
  collapsed: boolean;
  onToggle: () => void;
}

/**
 * Full-width grid row that heads one team's agent rows, styled like the
 * assignee dropdown's team group heading. Clicking it (or Enter / Space)
 * collapses or expands the team's rows; it stays visible while collapsed.
 *
 * The label is sticky on the x-axis so it stays beside the agent column when
 * the grid is scrolled horizontally.
 */
export function TeamSeparatorRow({
  teamName,
  agentCount,
  collapsed,
  onToggle,
}: TeamSeparatorRowProps) {
  return (
    <button
      type="button"
      aria-expanded={!collapsed}
      onClick={onToggle}
      className={cn(
        'col-span-full flex border-t border-border bg-muted/60 text-left hover:bg-muted',
        'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring',
        !collapsed && 'border-b',
      )}
    >
      <span className="sticky left-0 flex min-w-0 items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-muted-foreground">
        <ChevronDown
          className={cn('size-3.5 shrink-0 transition-transform', collapsed && '-rotate-90')}
          aria-hidden="true"
        />
        <span className="truncate text-foreground">{teamName}</span>
        <span className="shrink-0 tabular-nums">
          · {agentCount} {agentCount === 1 ? 'agent' : 'agents'}
        </span>
      </span>
    </button>
  );
}
